
import type { SVGProps } from 'react';
const SvgMeinSchiff7 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#mein-schiff-7_svg__a)">
      <path
        fill="#FFF374"
        d="M18.086 10.5h-5.672c-.225 0-.414-.159-.414-.372V7.873c0-.202.178-.372.414-.372h5.672c.225 0 .414.16.414.372v2.255c-.012.213-.19.373-.414.373"
      />
      <path
        fill="#263E6A"
        d="M18.496 18.401c-.933 0-1.653-.096-2.236-.246l1.66-4.439a.614.614 0 0 0-.369-.797l-.678-.247v-1.824h1.16a.645.645 0 0 0 .644-.645V7.696a.645.645 0 0 0-.644-.645h-1.854V6.51a.365.365 0 0 0-.365-.365h-2.647V5.117c0-.2-.163-.362-.362-.362h-1.772c-.2 0-.362.163-.362.362v1.028H7.515a.365.365 0 0 0-.365.365v1.519H5.748a.236.236 0 0 0-.236.236v1.12c0 .131.106.237.236.237h.93V12.7l-.68.24a.612.612 0 0 0-.372.795l1.617 4.35c-.62.19-1.354.316-2.275.316a.236.236 0 0 0 0 .473c2.186 0 3.375-.668 4.424-1.257.776-.435 1.446-.812 2.388-.812.982 0 1.506.343 2.17.776.882.576 1.98 1.292 4.546 1.292a.236.236 0 0 0 0-.472m-.291-10.705v2.507a.17.17 0 0 1-.172.173h-5.654a.17.17 0 0 1-.172-.173V7.696c0-.095.077-.172.172-.172h5.654c.095 0 .172.077.172.172m-7.062-2.469h1.551v.918h-1.55zm-3.52 1.39h8.084v.434h-3.328a.645.645 0 0 0-.644.645v.333H7.622zM5.983 8.501h5.75v.649h-5.75zm1.166 1.12h4.585v.582c0 .356.289.645.644.645H16.4V12.5l-4.073-1.48a1.5 1.5 0 0 0-.886-.003L7.15 12.533zm4.63 6.712c-1.065 0-1.82.424-2.62.873-.44.247-.908.51-1.47.725l-1.621-4.36a.143.143 0 0 1 .086-.185l5.444-1.924a1.03 1.03 0 0 1 .568.002l5.223 1.898q.056.02.083.076a.14.14 0 0 1 .004.113l-1.67 4.468c-.68-.234-1.155-.543-1.6-.834-.67-.438-1.305-.852-2.427-.852M10.645 12.3h2.267v.376c-.793.983-.929 1.686-.988 3.005h-.62c.059-1.199.286-1.956.938-2.862h-1.597zm2.461-2.417h-.312V8.029h.337l.576 1.042.191.395h.012c-.016-.191-.042-.426-.042-.632v-.805h.313v1.853h-.338l-.576-1.043-.191-.394h-.012c.016.196.042.42.042.626zm2.69 0h-1.144V8.029h1.115v.277h-.787v.474h.667v.277h-.667v.548h.815zm.371-.813V8.03h.329v1.065c0 .404.15.536.375.536.227 0 .383-.132.383-.536V8.03h.316v1.04c0 .609-.27.847-.7.847s-.703-.238-.703-.847"
      />
    </g>
    <defs>
      <clipPath id="mein-schiff-7_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMeinSchiff7;
